<ham-modal
    [title]="'aumico_abacus_connect_modal_title' | i18next"
    [hideFooter]="true"
    [size]="'sm'"
    (cancel)="onCancel()"
>
    <div class="abacus-modal-body">
        <!-- Step 1: form -->
        <section *ngIf="step === 'welcome'">
            <p class="abacus-modal-body__paragraph">
                {{ 'aumico_abacus_step_welcome_intro' | i18next }}
            </p>

            <div class="abacus-modal-body__field">
                <label for="abacusDisplayName">
                    {{ 'aumico_integration_setup_displayname_label' | i18next }}
                </label>
                <input
                    hamInput
                    id="abacusDisplayName"
                    type="text"
                    [(ngModel)]="displayName"
                    [placeholder]="'aumico_integration_setup_displayname_placeholder' | i18next"
                />
                <small class="abacus-modal-body__hint">
                    {{ 'aumico_abacus_step_config_displayname_help' | i18next }}
                </small>
            </div>

            <div class="abacus-modal-body__field">
                <label for="abacusServerUrl">
                    {{ 'aumico_abacus_step_config_serverurl_label' | i18next }}
                </label>
                <input
                    hamInput
                    id="abacusServerUrl"
                    type="url"
                    [(ngModel)]="serverUrl"
                    placeholder="https://abaweb.example.ch"
                />
                <small class="abacus-modal-body__hint">
                    {{ 'aumico_abacus_step_config_serverurl_help' | i18next }}
                </small>
            </div>

            <div class="abacus-modal-body__field">
                <label for="abacusClientId">
                    {{ 'aumico_abacus_step_config_clientid_label' | i18next }}
                </label>
                <input
                    hamInput
                    id="abacusClientId"
                    type="text"
                    [(ngModel)]="clientId"
                />
            </div>

            <div class="abacus-modal-body__field">
                <label for="abacusClientSecret">
                    {{ 'aumico_abacus_step_config_clientsecret_label' | i18next }}
                </label>
                <!--
                    NOT a `type="password"` input on purpose: Chrome auto offers
                    to save credentials whenever a real password field had a
                    value and its DOM is then replaced (which happens after
                    submit, when we swap in the testing step). We keep `type=text`
                    always and mask visually via `-webkit-text-security: disc`
                    when `showClientSecret` is false (see the .scss). The
                    "Anzeigen / Verbergen" toggle just flips the masked class.
                -->
                <input
                    hamInput
                    id="abacusClientSecret"
                    type="text"
                    [class.abacus-modal-body__secret-masked]="!showClientSecret"
                    [(ngModel)]="clientSecret"
                    autocomplete="off"
                    spellcheck="false"
                    data-lpignore="true"
                />
                <div class="abacus-modal-body__hint-row">
                    <small class="abacus-modal-body__hint">
                        {{ 'aumico_abacus_step_config_clientsecret_help' | i18next }}
                    </small>
                    <button
                        type="button"
                        class="abacus-modal-body__toggle"
                        (click)="onToggleClientSecret()"
                    >
                        {{
                            showClientSecret
                                ? ('aumico_abacus_step_config_clientsecret_hide' | i18next)
                                : ('aumico_abacus_step_config_clientsecret_show' | i18next)
                        }}
                    </button>
                </div>
            </div>

            <div class="abacus-modal-body__actions">
                <ham-button
                    variant="primary"
                    size="sm"
                    [disabled]="!isFormValid"
                    (buttonClick)="onSubmit()"
                >
                    {{ 'aumico_integration_connect_button' | i18next }}
                </ham-button>
                <ham-button variant="primary" size="sm" [outline]="true" (buttonClick)="onCancel()">
                    {{ 'aumico_button_cancel' | i18next }}
                </ham-button>
            </div>
        </section>

        <!-- Step 2: BE testing the credentials -->
        <section *ngIf="step === 'testing'" class="abacus-modal-body__loading">
            <div class="abacus-modal-body__spinner"></div>
            <p class="abacus-modal-body__paragraph">
                {{ 'aumico_integration_status_testing' | i18next }}
            </p>
            <ham-button variant="primary" size="sm" [outline]="true" (buttonClick)="onCancel()">
                {{ 'aumico_button_cancel' | i18next }}
            </ham-button>
        </section>

        <!-- Step 3: error from discovery / token / smoke test -->
        <section *ngIf="step === 'error'" class="abacus-modal-body__error">
            <div class="abacus-modal-body__error-icon">⚠</div>
            <h3 class="abacus-modal-body__title">{{ 'aumico_integration_status_error_title' | i18next }}</h3>
            <p class="abacus-modal-body__error-message">{{ errorMessage }}</p>
            <div class="abacus-modal-body__actions">
                <ham-button variant="primary" size="sm" (buttonClick)="onRetryFromError()">
                    {{ 'aumico_button_retry' | i18next }}
                </ham-button>
                <ham-button variant="primary" size="sm" [outline]="true" (buttonClick)="onCancel()">
                    {{ 'aumico_button_cancel' | i18next }}
                </ham-button>
            </div>
        </section>
    </div>
</ham-modal>
